import { GameVars } from "../../GameVars";
import { LevelSelectionScene } from "./LevelSelectionScene";
import { GameManager } from "../../GameManager";
import { RavalButton, RavalProgressBar, GeneralUtils } from "../../utils/Utils";
import { GameConstants } from "../../GameConstants";
import { AudioManager } from "../../AudioManager";

export class SelectionItem extends Phaser.GameObjects.Container {

    public backgroundButtonTween: Phaser.Tweens.Tween;

    private parentScene: LevelSelectionScene;
    private backgroundButton: RavalButton;
    private drawImage: Phaser.GameObjects.Image;
    private progressBar: RavalProgressBar;
    private drawID: number;
    private drawCategory: string;
    private itemWidth: number = 0;
    private itemHeight: number = 0;

    constructor(scene: LevelSelectionScene, drawID: number, DrawCategory: string) {

        super(scene);

        this.parentScene = scene;

        if (GameVars.aspectRatio <= 1.35) {
            this.itemWidth = Phaser.Math.FloorTo(GameConstants.GAME_WIDTH / 4.5 * GameVars.scaleXMultInverse);
            this.itemHeight = Phaser.Math.FloorTo(this.itemWidth * 1.4);
        } else {
            this.itemWidth = Phaser.Math.FloorTo(GameConstants.GAME_WIDTH / 3.5 * GameVars.scaleXMultInverse);
            this.itemHeight = Phaser.Math.FloorTo(this.itemWidth * 1.4);
        }

        this.drawID = drawID;
        this.drawCategory = DrawCategory;

        this.scaleX = GameVars.scaleXMult;
        this.scaleY = GameVars.scaleYMult;

        this.create();
    }

    public endTweenHandler(): void {
        this.backgroundButtonTween.stop();
    }

    public create(): void {

        this.backgroundButtonTween = this.parentScene.tweens.create({
            targets: [this],
            scaleX: GameVars.scaleXMult,
            scaleY: GameVars.scaleYMult,
            ease: "Elastic.easeOut",
            duration: 800,
            paused: true,
            onComplete: function () { GameVars.recentDrawFinishedCategoryID = -1; GameVars.recentDrawFinishedID = -1; },
        });

        if (GameVars.recentDrawFinishedCategoryID === GameManager.getIDfromCategory(this.drawCategory) && GameVars.recentDrawFinishedID === this.drawID) {
            AudioManager.playSound("draw_done");
            this.backgroundButtonTween.play(true);
        }

        // Create the image that will be the background WHEN THE DRAW IS FINISHED! 
        this.backgroundButton = new RavalButton(this.parentScene, Phaser.Math.FloorTo(-this.itemWidth / 2), Phaser.Math.FloorTo(- this.itemHeight / 2), "texture_atlas_1", "base_uncomplete.png", "base_uncomplete.png");
        this.backgroundButton.setOrigin(0.5);
        this.backgroundButton.setDisplaySize(this.itemWidth, this.itemHeight);
        this.backgroundButton.x += this.itemWidth * .5;
        this.backgroundButton.y += this.itemHeight * .5;
        this.add(this.backgroundButton);

        // Create the image of the draw in GS version 
        let drawFileName = GameManager.getFileFormatCategory(this.drawCategory) + "_draw_gs_" + GeneralUtils.getAsPaddedNumber(this.drawID + 1, 2) + ".png";
        this.drawImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_0", drawFileName);
        this.drawImage.setOrigin(0);

        let scaleFactor = (this.itemWidth - 65) / this.drawImage.width;

        this.drawImage.setScale(scaleFactor);
        this.drawImage.setPosition(this.backgroundButton.getCenter().x - (this.drawImage.width * this.drawImage.scaleX) / 2, this.backgroundButton.getCenter().y - (this.drawImage.height * this.drawImage.scaleY) / 2);
        this.drawImage.texture.setFilter(Phaser.Textures.FilterMode.NEAREST);
        this.add(this.drawImage);

        this.backgroundButton.onUp(function () {

            if (!this.parentScene.levelSelectionGUI.ignoreLoadLevel) {
                GameVars.currentDrawId = this.drawID;
                GameVars.currentDrawCategory = this.drawCategory;

                if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
                    if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                        gdsdk.showAd();
                        GameVars.typeAd = "Canvas";
                    } else {
                        this.scene.scene.start("CanvasScene");
                    }
                } else {
                    this.scene.scene.start("CanvasScene");
                }
            }

        }, this);

        // Create the progress bar 
        this.progressBar = new RavalProgressBar(this.parentScene, 0, this.itemHeight / 2, this.itemWidth - 40, 20, new Phaser.Display.Color(255, 50, 50), new Phaser.Display.Color(0, 240, 0), "bar_progress.png", 0, true);
        this.progressBar.interpolateColorBackground(new Phaser.Display.Color(255, 50, 50));
        this.progressBar.interpolateColorProgress(new Phaser.Display.Color(50, 255, 50));

        let drawstate = GameManager.getDrawState(
            GameManager.getIDfromCategory(this.drawCategory),
            this.drawID
        );

        switch (drawstate) {

            case drawState.DRAW_NULL:
            case drawState.DRAW_EMPTY:
                this.progressBar.setProgress(0);
                this.progressBar.visible = false;
                break;

            case drawState.DRAW_FINISHED:

                let catString = GameManager.getFileFormatCategory(this.drawCategory);

                let colorFrameString = catString + "_draw_" + GeneralUtils.getAsPaddedNumber(this.drawID + 1, 2) + ".png";
                this.drawImage.setTexture("texture_atlas_0", colorFrameString);
                this.drawImage.x += 3;
                this.backgroundButton.setTexture("texture_atlas_1", "base_complete.png");

                this.progressBar.visible = false;
                this.progressBar.setProgress(1);

                break;

            case drawState.DRAW_INPROGRESS:

                let filled = GameManager.getPixelData(GameManager.getIDfromCategory(this.drawCategory), this.drawID);
                this.progressBar.visible = true;

                if (filled) {
                    this.progressBar.setProgress(filled[2]);
                }

                break;

            default:
                break;
        }

        if (drawstate === drawState.DRAW_FINISHED) {
            this.progressBar.setProgress(1);
        }

        this.add(this.progressBar);
    }
}
